import { FormInputMeta } from '@Modules/core/types/FormMetaType';
import commonFormMeta from '@Shared/components/form/commonFormMeta';
import { capitalize } from '@Shared/utils/helpers';
import { getValidationSchema } from '@Shared/utils/validationSchema';
import * as yup from "yup";


export interface IApplicantFormMeta {
    title: FormInputMeta;
    firstname: FormInputMeta;
    lastname: FormInputMeta;
    surname: FormInputMeta;
    birthDate: FormInputMeta;
    birthPlace: FormInputMeta;
    firstIdentityType: FormInputMeta;
    firstIdentity: FormInputMeta;
    secondIdentityType: FormInputMeta;
    secondIdentity: FormInputMeta;
    gender: FormInputMeta;
    familySituation: FormInputMeta;
    nationality: FormInputMeta;    
    numberOfDependents: FormInputMeta;
    // Professional informations
    employeeCode: FormInputMeta;
    employeeName: FormInputMeta;
    employeePosition: FormInputMeta;
    grossSalary: FormInputMeta;
    netSalary: FormInputMeta;
    since: FormInputMeta;

    schema: any;
  }

const ApplicantFormMeta = {} as IApplicantFormMeta;


ApplicantFormMeta.title = {
  name: "title",
  label: "Titre",
  type: "select",
  options:  [
      {
        label: 'Titre A',
        value: 'a'
      },
      {
        label: 'Titre B',
        value: 'b',
      },
      {
        label: 'Titre C',
        value: 'b',
      },
    ],
    validation: yup.string().required("Ce champ est requis"),
}
ApplicantFormMeta.firstname = {
  name: "firstname",
  label: "Nom",
  type: "text",
  validation: yup.string().required("Ce champ est requis"),
}
ApplicantFormMeta.lastname = {
  name: "lastname",
  label: "Prenom",
  type: "text",
  validation: yup.string().required("Ce champ est requis"),
}
ApplicantFormMeta.surname = {
  name: "surname",
  label: "Surnom",
  type: "text",
  validation: yup.string().required("Ce champ est requis"),
}
ApplicantFormMeta.birthDate = {
  name: "birthDate",
  label: "Date de naissance",
  type: "date",
  validation: yup.string().required("Ce champ est requis"),
}
ApplicantFormMeta.birthPlace = {
  name: "birthPlace",
  label: "Lieu de naissance",
  type: "text",
  validation: yup.string().required("Ce champ est requis"),
}

ApplicantFormMeta.firstIdentityType = {
    name: "firstIdentityType",
    label: "Type 1ere Identité",
    type: "select",
    options:  [
        {
          label: 'Type A',
          value: 'a'
        },
        {
          label: 'Type B',
          value: 'b',
        },
        {
          label: 'Type C',
          value: 'b',
        },
      ],
      validation: yup.string().required("Ce champ est requis"),
}
ApplicantFormMeta.firstIdentity = {
    name: "firstIdentity",
    label: "1ere Identité",
    type: "text",
    validation: yup.string().required("Ce champ est requis"),
}
ApplicantFormMeta.secondIdentityType = {
  name: "secondIdentityType",
  label: "Type 2nde Identité",
  type: "select",
  options:  [
      {
        label: 'Type A',
        value: 'a'
      },
      {
        label: 'Type B',
        value: 'b',
      },
      {
        label: 'Type C',
        value: 'b',
      },
    ],
    validation: yup.string().required("Ce champ est requis"),
}
ApplicantFormMeta.secondIdentity = {
  name: "secondIdentity",
  label: "2nde Identité",
  type: "text",
  validation: yup.string().required("Ce champ est requis"),
}

ApplicantFormMeta.gender = {
    name: "gender",
    label: "Sexe",
    type: "select",
    options:  [
        {
          label: 'Male',
          value: 'a'
        },
        {
          label: 'Femelle',
          value: 'b',
        },
        {
          label: 'Autre',
          value: 'b',
        },
      ],
    validation: yup.string().required("Ce champ est requis"),
}
ApplicantFormMeta.familySituation = {
  name: "familySituation",
  label: "Situation familiale",
  type: "select",
  options:  [
      {
        label: 'Situation A',
        value: 'a'
      },
      {
        label: 'Situation B',
        value: 'b',
      },
      {
        label: 'Situation C',
        value: 'b',
      },
    ],
  validation: yup.string().required("Ce champ est requis"),
}
ApplicantFormMeta.nationality = {
  name: "nationality",
  label: "Nationalité",
  type: "select",
  options:  [
      {
        label: 'Nationalité A',
        value: 'a'
      },
      {
        label: 'Nationalité B',
        value: 'b',
      },
      {
        label: 'Nationalité C',
        value: 'b',
      },
    ],
  validation: yup.string().required("Ce champ est requis"),
}
ApplicantFormMeta.numberOfDependents = {
    name: "numberOfDependents",
    label: "Nombre de personnes à charge",
    type: "number",
    validation: yup.string().required("Ce champ est requis"),
}


ApplicantFormMeta.employeeCode = {
  name: "employeeCode",
  label: "Code employé",
  type: "text",
  validation: yup.string().required("Ce champ est requis"),
}
ApplicantFormMeta.employeeName = {
  name: "employeeName",
  label: "Nom employé",
  type: "text",
  validation: yup.string().required("Ce champ est requis"),
}
ApplicantFormMeta.employeePosition = {
    name: "employeePosition",
    label: "Position ou titre",
    type: "select",
    options:  [
        {
          label: 'Position ou titre A',
          value: 'a'
        },
        {
          label: 'Position ou titre B',
          value: 'b',
        },
        {
          label: 'Position ou titre C',
          value: 'b',
        },
      ],
    validation: yup.string().required("Ce champ est requis"),
}
// Salaire Par Mois
ApplicantFormMeta.grossSalary = {
    name: "grossSalary",
    label: "Salaire brut par mois",
    type: "number",
    validation: yup.string().required("Ce champ est requis"),
}
ApplicantFormMeta.netSalary = {
  name: "netSalary",
  label: "Salaire net par mois",
  type: "number",
  validation: yup.string().required("Ce champ est requis"),
}
ApplicantFormMeta.since = {
  name: "since",
  label: "Depuis (JJ/MM/AAAA)",
  type: "date",
  validation: yup.string().required("Ce champ est requis"),
}



ApplicantFormMeta.schema = yup.object().shape(getValidationSchema(ApplicantFormMeta));

export default ApplicantFormMeta;